// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__26ijf","clinicsSelect":"styles_clinicsSelect__1ga8z"};